import { CodeOutlined } from '@ant-design/icons';
import { OPERATIONS } from 'constants';

const generativeAI = {
  id: 'generative_ai',
  title: 'Generative AI',
  type: 'group',
  children: [
    {
      id: 'prompt_library',
      title: 'Prompt Library',
      type: 'item',
      url: '/generative-ai/prompt-library',
      icon: CodeOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT, OPERATIONS.DELETE]
    }
  ]
};

export default generativeAI;
